module.exports = __webpack_public_path__ + "73df3a0bf6f8b2bc93dc6ceca347e680.png";